import script from "./ArchiveContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArchiveContent.vue?vue&type=script&lang=ts&setup=true"

import "./ArchiveContent.vue?vue&type=style&index=0&id=5ddf5130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ddf5130"]])

export default __exports__